import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../components/Wrapper/GlobalWrapper";
import { Box, Card, Chip, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GlobalDatagrid from "../../components/mui/DataGrid/GlobalDatagrid";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Assessment_Course_Head } from "../../components/datagrid/assessment/AssessmentCourseTableHead";
import GlobalMultiSelect from "../../components/mui/GlobalMultiSelect";
import { useLocation, useNavigate } from "react-router-dom";
import { getCourseWiseDetails } from "../../redux/features/assessmentDashboardSlice";
import FromAndToDatePicker from "../../components/mui/FromAndToDatePicker";

const AssessmentCourseView = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate("");
  const searchParams = new URLSearchParams(location.search);
  const userID = searchParams.get("userID");
  const courseName = searchParams.get("course_name");
  const fromdate = searchParams.get("fromDate");
  const todate = searchParams.get("toDate");
  const [fromDate, setFromDate] = useState(
    fromdate || dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(
    todate || dayjs().endOf("month").format("YYYY-MM-DD")
  );

  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const { loading, coursewiseData } = useSelector(
    (state) => state.assessmentDashboard
  );

  useEffect(() => {
    dispatch(
      getCourseWiseDetails({
        fromDate: dayjs(fromDate).format("YYYY-MM-DD"),
        toDate: dayjs(toDate).format("YYYY-MM-DD"),
        userID: userID,
        dateFilter: 1,
        course_name: courseName,
      })
    );
  }, [fromDate, toDate]);

  return (
    <GlobalWrapper title={"Assessment Report"}>
      <Box
        sx={{ display: "flex", justifyContent: "flex-start", pb: 2, gap: 1 }}
      >
        <Box>
          <Card
            sx={{
              background:
                "linear-gradient(135deg,rgba(0, 139, 208, 0.79),rgba(160, 37, 194, 0.74))",
              color: "#fff",
              borderRadius: 1,
              width: "100%",
              maxWidth: 350,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 2,
            }}
          >
            <Chip
              label={courseName}
              variant="outlined"
              sx={{
                backgroundColor: "white",
                color: "#a125c2",
                fontWeight: 500,
                fontSize: "1rem",
                padding: 1,
              }}
            ></Chip>
          </Card>
        </Box>
        <Box>
          <FromAndToDatePicker
            disabled={false}
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
          />
        </Box>
      </Box>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={Assessment_Course_Head(
            navigate,
            courseName,
            userID,
            fromdate,
            todate
          )}
          rows={coursewiseData?.data}
          // meta={smeLeads?.meta?.totalRecords || 0}
          rowUniqueId="id"
          loading={loading}
          rowClick={false}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default AssessmentCourseView;
